export default {
  // User & Auth
  user: null,
  orgId: null,
  authenticated: false,
  sessionToken: null,
  loading: false,
  error: null,
  currentMemberProfile: null,
  
  // Permissions (global, effective across sources)
  effectivePermissions: null,
  permissionsReady: false,
  
  // Knowledge Base (Document Management)
  documents: [],
  documentContext: null,
  documentHistory: [],
  
  // Graph Management
  graphNodes: [],
  graphEdges: [],
  selectedNode: null,
  selectedEdge: null,
  graphLoading: false,
  graphError: null,
  graphNodeTypes: [],
  graphEdgeTypes: [],
  graphDateRange: null,
  graphLayoutName: 'cose',
  graphLayoutOptions: {
    name: 'cose',
    animate: false,
    refresh: 20,
    fit: true
  },
  graphTotalNodes: 0,
  graphTotalEdges: 0,
  graphLastUpdated: null,

  // Chat & Interactions
  conversations: [],
  activeConversation: null,
  messages: [],
  chatModel: 'gpt-4o-mini',
  chatInstructions: '',

  // Queues
  queues: [],

  // Integrations & Processing
  integrations: [],
  processingQueue: [],
  processingStatus: {},
  currentBatch: null,

  // UI State
  sidebarOpen: true,
  activeView: 'dashboard',
  chatWindowOpen: false,
  showNotification: false,
  chatOpen: false,
  menuOpen: false,
  mobileMenuOpen: false,
  notifications: [],

  // Subscription Plans
  subscriptionPlans: [
    {
      name: 'Starter',
      credits: 1000,
      price: 0.00,
      priceId: "price_starter",
      features: [
        '🧠 Basic Knowledge Base',
        '💬 1 AI Agent',
        '📝 Document Processing',
        '🔗 1 Integration'
      ]
    },
    {
      name: 'Pro',
      credits: 10000,
      price: 49.99,
      priceId: 'price_pro',
      features: [
        '🗄️ Advanced Knowledge Management',
        '🤖 Unlimited AI Agents',
        '📊 Advanced Analytics',
        '🔄 Custom Workflows',
        '🔗 Unlimited Integrations'
      ]
    },
    {
      name: 'Enterprise',
      credits: "Custom",
      price: "Custom",
      priceId: 'price_enterprise',
      features: [
        '🏢 Custom Infrastructure',
        '🔒 Private Knowledge Graph',
        '📈 Custom Analytics',
        '🤝 Dedicated Support',
        '✨ Custom AI Models'
      ]
    }
  ]
};
